export const pluralizeSlateLabel = (count: number, label = 'Slate') => {
  if (count === 1) {
    return label;
  }

  return `${label}s`;
};

export const getSlateLabel = (label: string) => {
  const slateLabel = label?.toLowerCase();

  if (slateLabel === 'week') return 'Weekly';
  if (slateLabel === 'day') return 'Daily';

  return label ?? 'Slate';
};
